// import { MdCalendarMonth } from "react-icons/md";
// import { FaArrowTrendUp } from "react-icons/fa6";
import { Button } from "primereact/button";
// import contactsSVG from "../../../assets/svg/ContactsLight.svg";
// import contactsDarkSVG from "../../../assets/svg/ContactsDark.svg";
import { useIPContext } from "app/pages/InteractiveProposal/InteractiveProposalProvider";
import { useEffect } from "react";
import { ProposalTypes } from "app/utils/types";
// import YearIcon from "../../../assets/IconComponent/YearIcon";
import YearIcon from "app/assets/IconComponent/YearIcon";
import PlanYearIcon from "app/assets/IconComponent/PlanYearIcon";
import InsuredAgeIcon from "app/assets/IconComponent/InsuredAgeIcon";

export const getTooltipLabel = (selectedChartFilter: string) => {
  switch (selectedChartFilter) {
    case "insuredAge":
      return "Insured";
    case "planYear":
      return "Plan Year";
    case "year":
      return "Year";
    default:
      return "";
  }
};

const ChartFilter = () => {
  const {
    isInsuredDisabled,
    setSelectedChartFilter,
    selectedChartFilter,
    themeState,
    summaryData: proposalSummary,
  } = useIPContext();

  const options = [
    {
      // icon: <MdCalendarMonth color={themeState === "dark" ? "white" : "black"} />,
      icon: <YearIcon fillColor={themeState === "dark" ? "white" : "black"} />,
      value: "year",
      tooltip: "Year",
    },
    {
      icon: <PlanYearIcon fillColor={themeState === "dark" ? "white" : "black"} />,
      value: "planYear",
      tooltip: "Plan Year",
    },
    {
      icon: <InsuredAgeIcon fillColor={themeState === "dark" ? "white" : "black"} />,
      value: "insuredAge",
      isDisabled: isInsuredDisabled,
      tooltip: "Insured Age",
    },
  ];

  useEffect(() => {
    if (proposalSummary?.proposalType === ProposalTypes.PremiumFinance) {
      setSelectedChartFilter("planYear");
    } else {
      setSelectedChartFilter("year");
    }
  }, []);

  const handleClick = () => {
    const currentIndex = options.findIndex((opt) => opt.value === selectedChartFilter);
    let nextIndex = (currentIndex + 1) % options.length;

    // Skip disabled options
    while (options[nextIndex].isDisabled) {
      nextIndex = (nextIndex + 1) % options.length;
    }

    setSelectedChartFilter(options[nextIndex].value);
  };

  const currentOption = options.find((opt) => opt.value === selectedChartFilter) || options[0];

  return (
    <div className="ml-1 mb-1">
      <Button
        outlined
        icon={currentOption.icon}
        size="small"
        className="p-2 !border-0 !bg-none"
        severity="info"
        tooltipOptions={{ position: "top" }}
        tooltip={currentOption.tooltip}
        onClick={handleClick}
      />
    </div>
  );
};

export default ChartFilter;
